import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import resetPassword from '@/components/resetPassword'
import index from '@/components/index'
import error from '@/components/error'
import loading from '@/components/loading'
import calendar from '@/components/calendar'
import Mine from '@/components/views/Mine.vue'
import H5inviter from '@/components/H5inviter.vue'
import shareRegister from '@/components/shareRegister.vue'
import userAgreement from '../components/views/userAgreement.vue'
import privacy from '../components/views/privacy.vue'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: resetPassword
    },
    {
      path: '/index',
      name: 'index',
      component: index,
    },
    {
      path: '/mine',
      name: 'mine',
      component: Mine
    },
    {
      path: '/loading',
      name: 'loading',
      component: loading
    },
    {
      path: '*',
      component: error
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: calendar
    },
    {
      path:'/H5inviter',
      name: 'H5inviter',
      component: H5inviter
    },
    {
      path: '/shareRegister',
      name: 'shareRegister',
      component: shareRegister
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js